/**
 * @file: PendingIssueType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum PendingIssueType {
  Default = 'default',
  Fault = 'fault',
}

export const PendingIssueTypeValueSet = new Set([
  PendingIssueType.Default,
  PendingIssueType.Fault,
]);
